<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog
            title="正在修改密码"
            :close-on-click-modal="false"
            :visible.sync="visibleSync"
            ref="form"
            width="70%">
        <el-form :model="info" ref="form" :rules="rules" label-width="100px">
            <el-form-item label="原密码" prop="oldPassword">
                <el-input v-model="info.oldPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
                <el-input v-model="info.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="重复新密码" prop="passwordConfirm">
                <el-input v-model="info.passwordConfirm" type="password"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()">确认</el-button>
                <el-button @click="cancel()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        name: '',
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            const checkPasswordConfirm = (rule, value, callback) => {
                if (value !== this.info.password) {
                    callback(new Error('两次输入的密码不同'));
                }
                callback();
            };
            return {
                visibleSync: null,
                info: {},
                rules: {
                    oldPassword: [
                        {required: true, message: '原密码不能为空'},
                        {min: 6, max: 20, message: '长度在 6 到 20 位字符'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空'},
                        {min: 6, max: 25, message: '密码长度在 6 到 25 位字符'}
                    ],
                    passwordConfirm: [
                        {required: true, message: '密码不能为空'},
                        {validator: checkPasswordConfirm, trigger: 'change'}
                    ]
                }
            };
        },
        methods: {
            confirm () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    this.$normalRequest('user/updateSelfPassword', {
                        old_password: this.info.oldPassword,
                        password: this.info.password
                    }, '密码修改成功').then(_ => {
                        this.closeAndClear();
                    }).catch(_ => {
                    });
                });
            },
            closeAndClear () {
                this.$refs.form.resetFields();
                this.close();
            },
            close () {
                this.cancel();
            },
            cancel () {
                this.$refs.form.clearValidate();
                this.visibleSync = false;
            }
        }
    };
</script>
